import { render, staticRenderFns } from "./administrationAgency.vue?vue&type=template&id=47c8c501&scoped=true&"
import script from "./administrationAgency.vue?vue&type=script&lang=js&"
export * from "./administrationAgency.vue?vue&type=script&lang=js&"
import style0 from "./administrationAgency.vue?vue&type=style&index=0&id=47c8c501&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8c501",
  null
  
)

export default component.exports